module.exports = __webpack_public_path__ + "static/media/extension.a3fe288d.jpg";